<template>
  <div id="my-rewards-codes-tab">
    <b-row no-gutters="">
      <b-col>
        <RewardsNav></RewardsNav>
      </b-col>
    </b-row>
    <div class="rewards-body">
      <b-row v-if="rewardDetails">
        <b-col>
          <router-link
            :to="{ name: 'MyRewards' }"
            class="text-secondary align-middle fs-14 fw-600"
          >
            Rewards
          </router-link>
          <img
            src="@/assets/images/icons/chevron-right.svg"
            class="mx-2"
            alt="Chevron Right"
          />
          <span class="text-primary align-middle font-weight-bold fs-14"
            >{{ rewardDetails.name }} Codes</span
          >
        </b-col>
      </b-row>
      <b-row class="my-4" v-if="rewardDetails">
        <b-container>
          <b-col md="3" class="bg-white rounded p-3 bl-2-blue">
            <div class="text-secondary fs-13 font-weight-normal">
              Reward Name
            </div>
            <div class="text-dark fw-600 fs-20">
              {{ rewardDetails.name }}
            </div>
          </b-col>
        </b-container>
      </b-row>
      <b-row>
        <b-col>
          <div class="rewards-content">
            <div class="mb-2">
              <b-row>
                <b-col sm="5" md="4">
                  <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                      <b-input
                        placeholder="Search"
                        v-model="searchKeyword"
                        @keyup.native="fetchCodes(1)"
                      ></b-input>
                      <b-dropdown
                        text="Advanced"
                        variant="primary"
                        slot="append"
                      >
                        <b-dropdown-item
                          v-for="option in codeStatusOptions"
                          :key="option.value"
                          @click="codeStatus = option.value"
                        >
                          {{ option.text }}
                          <i
                            v-if="codeStatus === option.value"
                            class="ml-1"
                          >
                            <img
                              width="15"
                              height="15"
                              src="@/assets/images/checked-symbol.svg"
                              alt=""
                              class="mr-1"
                            />
                          </i>
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col sm="6" md="3" class="mt-3 mt-md-0">
                  <b-input-group>
                    <b-input-group slot="append">
                      <i
                        class="icon-calendar"
                        style="cursor: pointer"
                        data-toggle
                        @click="openRangePicker"
                      ></i>
                      <i
                        class="icon-clear"
                        style="cursor: pointer"
                        data-toggle
                        @click="clearRangePicker"
                      ></i>
                    </b-input-group>
                    <datepicker
                      ref="rangePicker"
                      v-model="dateRange"
                      :config="dateRangeConfig"
                      class="form-control"
                      placeholder="Select Date Range"
                      name="date"
                    >
                    </datepicker>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>
            <div class="mt-2">
              <div class="data-container position-relative">
                <b-table
                  responsive
                  :items="codes"
                  :fields="fields"
                  :current-page="currentPage"
                  show-empty
                  :empty-text="status"
                >
                  <template slot="is_used" slot-scope="data">
                    <span class="pill-green" v-if="data.value"> Sent </span>
                    <span class="pill-blue" v-else> Available </span>
                  </template>
                  <template slot="updated_at" slot-scope="data">
                    {{ data.item.is_used ? $moment(data.value).format("MM/DD/YYYY") : '' }}
                  </template>
                </b-table>
              </div>
            </div>
            <div>
              <b-row v-if="codes.length">
                <b-col>
                  <div class="mt-1">
                    <span class="pagination-indicator">
                      Showing {{ firstItemPage }} to
                      {{ lastItemPage("codes") }} of {{ maxPage }} per page
                    </span>
                  </div>
                </b-col>
                <b-col>
                  <b-pagination
                    align="right"
                    size="md"
                    :limit="3"
                    :total-rows="maxPage * codes.length"
                    :per-page="codes.length"
                    @change="paginate"
                    :value="currentPage"
                    class="custom-pagination"
                  >
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import RewardsNav from "./RewardsNav.vue";
import Datepicker from "vue-bulma-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "MyRewardsCodesTab",
  props: ["rewardUuid"],
  data() {
    return {
      fields: [
        { key: "redeem_code", label: "Codes", sortable: true },
        { key: "is_used", label: "Status", sortable: true },
        { key: "updated_at", label: "Date", sortable: true },
      ],
      searchKeyword: "",
      codeStatus: "all",
      status: "Loading...",
      codeStatusOptions: [
        { value: "all", text: "All" },
        { value: "unused", text: "Available" },
        { value: "used", text: "Sent" },
      ],
      rangePicker: null,
      dateRange: null,
    };
  },
  created() {
    this.viewReward(this.rewardUuid);
    this.fetchCodes();
  },
  computed: {
    ...mapState("rewards", [
      "rewardDetails",
      "codes",
      "maxPage",
      "currentPage",
      "loading",
    ]),
    ...mapGetters("rewards", ["firstItemPage", "lastItemPage"]),
    dateRangeConfig: {
      get: function () {
        const _this = this;
        return {
          altInput: true,
          altFormat: "M j, Y",
          dateFormat: "Y-m-d",
          static: true,
          mode: "range",
          defaultDate: null,
          onChange:(_, dateRange) => {
            if (dateRange.includes("to")) _this.fetchCodes();
          },
          onReady: (_, __, instance) => {
            _this.rangePicker = instance;
          },
        };
      },
    },
  },
  watch: {
    codeStatus() {
      this.fetchCodes();
    },
  },
  components: {
    RewardsNav,
    Datepicker,
  },
  methods: {
    ...mapActions("rewards", ["viewReward", "getCodes"]),
    openRangePicker() {
      if (this.rangePicker)this.rangePicker.toggle();
    },
    clearRangePicker() {
      if (this.rangePicker === null) return false;
      
      this.rangePicker.clear();
      if (this.dateRange !== null) {
        this.dateRange = null;
        this.fetchCodes();
      }
    },
    paginate(page) {
      return this.fetchCodes(page);
    },
    async fetchCodes(page = 1) {
      const payload = {
        reward_uuid: this.rewardUuid,
        search: {
          status: this.codeStatus,
        },
      };

      if (this.searchKeyword) 
        payload.search.redeem_code = this.searchKeyword;

      if (this.dateRange) {
        const formattedDateRange = this.dateRange.split(" to ");

        payload.search.start_date = formattedDateRange[0];
        payload.search.end_date = formattedDateRange[1];
      }

      await this.getCodes({ payload, page });

      if (!this.codes.length) this.status = "No Records Found";
    },
  },
};
</script>

<style lang="scss">
</style>
